import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
export function RegionFlag() {
    var _a;
    var classPrefix = useConfig().classPrefix;
    var className = classNames((_a = {},
        _a[classPrefix + "-flag"] = true,
        _a[classPrefix + "-flag-Globe--gray"] = true,
        _a));
    return React.createElement("span", { className: className });
}
RegionFlag.displayName = "RegionFlag";
//# sourceMappingURL=RegionFlag.js.map